import React, { useEffect } from "react";
import ChatWidget from "../components/ChatWidget";

// Renders ONLY the floating ARIA widget on a transparent page,
// intended to be loaded inside an iframe by /aria-widget.js.
export default function Embed() {
  useEffect(() => {
    const prevHtml = document.documentElement.style.background;
    const prevBody = document.body.style.background;
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    return () => {
      document.documentElement.style.background = prevHtml;
      document.body.style.background = prevBody;
    };
  }, []);

  return <ChatWidget />;
}
